import { restfulClient, actionClient } from '@/api'

const categoryUrl = '/credit-goods/category'

export const categoryApi = params => restfulClient.getCollection(categoryUrl, params)
export const categoryCreateApi = params => restfulClient.create(categoryUrl, params)
export const categoryUpdateApi = params => restfulClient.update(categoryUrl, params.id, params)
export const categoryRemoveApi = id => restfulClient.remove(categoryUrl, id)

